<template>
  <div class="header-nav flex-center">
    <div class="nav-content">
      <div class="content-left">
        <img
          class="logo"
          :src="platformConfig.logo"
          :style="`height: ${platformConfig.logoHeight}px`"
          alt="平台logo"
          @click="jump"
        />
        <el-divider v-if="sectionTitle" direction="vertical" />
        <span v-if="sectionTitle" class="route-title">{{ sectionTitle }}</span>
      </div>
      <div v-if="!hideLogin && !isLogin">
        已有账号？
        <el-button
          type="text"
          size="medium"
          @click="goToLogin"
        >立即登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'HeaderNav',

  props: {
    hideLogin: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      sectionTitle: this.$route.meta.workbenchTitle || ''
    }
  },

  computed: {
    ...mapState('user', ['isLogin']),
    ...mapGetters('system', ['platformConfig'])
  },

  methods: {
    jump() {
      window.location.href = process.env.VUE_APP_PORTAL_URL
    },

    goToLogin() {
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-nav {
  width: 100%;
  height: pixel-to-rem($n: 100);
  background-color: $white-color;

  .nav-content {
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .content-left {
      display: flex;
      align-items: center;

      .logo {
        cursor: pointer;
      }

      ::v-deep .el-divider {
        &.el-divider--vertical {
          height: 2em;
          margin: 0 18px;
        }
      }

      .route-title {
        font-size: 18px;
      }
    }
  }
}
</style>
